import { t } from "@bezbolisno/i18n";
import { can } from "@bezbolisno/kit/rbac";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { PageHeader } from "../../../components/page-header";
import { GiftCreatePageForm, giftFormData } from "../../../screens/gifts/gift-create-form";
import { pricingBoardQuery } from "../../../screens/pricing/queries";

/** Certificate sale as a full page: the form beside a live artwork preview. */
export const Route = createFileRoute("/_authed/gifts/new")({
  beforeLoad: ({ context }) => {
    if (!can(context.session.role, "gift:manage")) throw redirect({ to: "/" });
  },
  // Presets/specialists are best-effort (the old page swallowed load failures): prefetch,
  // never block on it.
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(pricingBoardQuery);
  },
  component: () => {
    const board = useQuery(pricingBoardQuery);
    const { presets, specialists } = giftFormData(board.data ?? null);
    return (
      <div className="fade-in">
        <PageHeader title={t.gifts.newGift} />
        <GiftCreatePageForm
          key={board.data ? "ready" : "empty"}
          presets={presets}
          specialists={specialists}
        />
      </div>
    );
  },
});
